(ns app.strive-forms.views
  (:require ["react-swipeable-views$default" :as SwipeableViews]
            ["uuid/v4" :as uuidv4]
            [app.components.headers.views :refer [header]]
            [app.routes :as routes]
            [app.strive-forms.components :refer [action-button
                                                 form-page-footer form-page-header gap-space
                                                 language-selection multi-question-page-header multi-question-page-header-slider
                                                 question-card]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as events]
            [app.strive-forms.helper-functions :refer [get-button-label
                                                       get-default-value
                                                       handle-scroll-event]]
            [app.strive-forms.question-fields.thank-you :refer [thank-you-field]]
            [app.strive-forms.responses-preview :refer [mobile-progress-bar
                                                        responses-preview]]
            [app.strive-forms.styles :refer [form-background
                                             form-container-theme form-content-style
                                             question-card-container-style questions-area-style response-drawer-style]]
            [app.strive-forms.subs :as subs]
            [clojure.string :refer [blank?]]
            [clojure.string :as s]
            [goog.string.format]
            [moment]
            [re-com.core :as re-com :refer [at box h-box v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent-mui.material.swipeable-drawer :refer [swipeable-drawer]]
            [reagent.core  :as r]
            [helins.timer :as timer]))

(defn question-body-page [{:keys [fields-count index selected-language theme-data form-messages current-page hidden-fields input-data on-submit
                                  pre-filled regenerate-display-fields display-fields input-value error-fn-props is-multi-question? final-page?
                                  additional-text visible? visible-id? button-ids-for-button question-field language-direction missing-required-fields steps-total]}]

  (map-indexed (fn [temp-index field]
                 ^{:key (str temp-index (:id field))}
                 (r/as-element [:div
                                {:key (str temp-index (:id field))
                                 :id (str "question-field-area-" (:id field))}
                                [v-box
                                 :children [(if (= temp-index 0)
                                              [:div
                                               (when is-multi-question?
                                                 [multi-question-page-header {:field field :theme-data theme-data
                                                                              :selected-language selected-language}])
                                               [gap-space {:primary-gap (:header-to-question-question-card (:gaps-primary default-values))
                                                           :secondary-gap (:header-to-question-question-card (:gaps-mobile-view default-values))}]]
                                              [gap-space {:primary-gap (:between-questions-gap (:gaps-primary default-values))
                                                          :secondary-gap (:between-questions-gap (:gaps-mobile-view default-values))}])
                                            [question-card {:field field :field-id (:id field)
                                                            :index index :fields-count fields-count
                                                            :selected-language selected-language
                                                            :theme-data theme-data :language-direction language-direction
                                                            :form-messages form-messages :visible? visible? :visible-id? visible-id?
                                                            :current-page current-page :final-page? final-page?
                                                            :hidden-fields hidden-fields :input-data input-data
                                                            :on-submit on-submit :pre-filled pre-filled
                                                            :regenerate-display-fields regenerate-display-fields :display-fields display-fields
                                                            :additional-text additional-text
                                                            :input-value input-value :error-fn-props error-fn-props
                                                            :is-multi-question? is-multi-question? :button-ids-for-button button-ids-for-button
                                                            :default-value (get-default-value {:default-value (:value (:default_value field))
                                                                                               :hidden-fields hidden-fields})
                                                            :missing-required-fields missing-required-fields :steps-total steps-total}]]]]))
               question-field))

(defn form-swipeable-panel [{:keys [index display-fields selected-language theme-data form-messages current-page hidden-fields
                                    input-data on-submit pre-filled regenerate-display-fields grouped-display-fields language-direction
                                    step steps-total missing-required-fields]}]
  (let [field (:fields (nth grouped-display-fields index))
        fields-count (if (= "thank_you_screen" (:type (last display-fields)))
                       (dec (count display-fields))
                       (count display-fields))
        input-value (r/atom [])
        additional-text (r/atom nil)
        error-fn-props (r/atom nil)
        visible? (r/atom false)
        visible-id? (r/atom nil)
        is-multi-question? (if (> (count field) 1) true false)
        filled-question-ids (r/atom (map key (filter #(and (not= [] (:value (val %))) (not= nil (:value (val %))) (not= "" (:value (val %)))) input-data))) ;TODO: not required
        button-ids-for-button (r/atom (into #{} (remove (fn [value] (some #(= value %) @filled-question-ids)) (into #{} (map #(keyword (:id %)) field)))))
        button-label (get-button-label {:index index :input-data input-data
                                        :form-messages form-messages
                                        :field-type (:type field)
                                        :next-page? (not= @step @steps-total)})
        is-preview-btn? (r/atom false)]
    (r/as-element
     [v-box
      :class (question-card-container-style)
      :style {:direction language-direction}
      :children [[:div {:class (questions-area-style)
                        :key (str "swipable-key-" (:id field))}
                  [question-body-page {:fields-count fields-count :index index :selected-language selected-language :theme-data theme-data :form-messages form-messages
                                       :current-page current-page :hidden-fields hidden-fields :input-data input-data :on-submit on-submit
                                       :pre-filled pre-filled :regenerate-display-fields regenerate-display-fields :display-fields display-fields
                                       :input-value input-value :additional-text additional-text
                                       :final-page? (= @step @steps-total)
                                       :error-fn-props error-fn-props :language-direction language-direction
                                       :visible? visible? :visible-id? visible-id? :is-multi-question? is-multi-question?
                                       :button-ids-for-button button-ids-for-button :question-field field :missing-required-fields missing-required-fields
                                       :steps-total steps-total}]]
                 [gap-space {:primary-gap (:error-message-to-action-button (:gaps-primary default-values))
                             :secondary-gap (:error-message-to-action-button (:gaps-mobile-view default-values))}] 
                  
                 [action-button {:field-id (:id field) :index index :input-data input-data :form-messages form-messages
                                 :theme-data theme-data  :current-page current-page :regenerate-display-fields regenerate-display-fields
                                 :button-label button-label :on-submit on-submit :fields field
                                 :input-value input-value :additional-text additional-text
                                 :is-multi-question? is-multi-question? :grouped-display-fields grouped-display-fields :display-fields display-fields
                                 :button-ids-for-button button-ids-for-button :final-page? (= @step @steps-total)
                                 :is-preview-btn? is-preview-btn? :missing-required-fields missing-required-fields}]]])))

(defn- jump-to-next-question? [index pre-filled counter]
  (and (zero? index) (some? pre-filled) (zero? @counter)))

(defn jump-to-next-question! [{:keys [input-data display-fields pre-filled current-page index counter steps-total]}]
  (#(re-frame/dispatch [::events/update-input-local
                        {:input-data input-data :key (keyword (:id (nth display-fields 0))) :value pre-filled}])
   (when (> @steps-total 0)
     (reset! current-page (inc index))
     (reset! counter (inc @counter)))))

(defn update-group-fields-map [x result]
  (mapv (fn [field]
          (if (= (:group_id field) (:group_id x))
            (update field :fields conj x)
            field)) result))

(defn create-group-display-fields [display-fields]
  (reduce
   (fn [result x]
     (if (nil? (some #(= (:group_id %) (:group_id x)) result))
       (conj result {:group_id (:group_id x) :fields [x]})
       (update-group-fields-map x result)))
   [] display-fields))



(defn question-page [{:keys [theme-data current-page selected-language hidden-fields display-fields pre-filled open-drawer
                             steps-total scrolled? page-titles children-element grouped-display-fields
                             counter input-data form-messages on-submit regenerate-display-fields form-icon allowed-languages language-direction review-responses step form_id missing-required-fields]}]
  (when (and (> @current-page 0) (not= nil @scrolled?) (some? children-element))
    (.addEventListener (.item children-element @current-page) "scroll" (fn [event] (handle-scroll-event {:event event
                                                                                                         :scrolled? scrolled?}))))
  [h-box
   :src (at)
   :children [[v-box
               :height "100vh"
               :justify :start
               :size "4"
               :children [(when-not (empty? page-titles)
                            (if (and @scrolled?
                                     (not (s/blank? (:page_title (nth page-titles @current-page)))))
                              [multi-question-page-header-slider {:field (nth page-titles @current-page) :theme-data theme-data
                                                                  :selected-language selected-language}]
                              [gap-space {:primary-gap "50px"
                                          :secondary-gap (:page-start-to-languages (:gaps-mobile-view default-values))}]))
                          [:div {:style {:background-position "53% top"
                                         :background-size "cover"}
                                 :class (form-background {:opacity (:image_opacity theme-data)
                                                          :url (:background_image_url theme-data)})}]
                         (when (and
                                 (not (and
                                       (= "thank_you_screen" (:type (last display-fields)))
                                       (= @step (inc @steps-total))))
                                 (> (count allowed-languages) 1))
                            [language-selection {:allowed-languages allowed-languages  :selected-language selected-language :form-id form_id}])
                          [gap-space {:primary-gap (:languages-to-header-gap (:gaps-primary default-values))
                                      :secondary-gap (:languages-to-header-gap (:gaps-mobile-view default-values))}]
                          (when (and
                                 (not (and
                                       (= "thank_you_screen" (:type (last display-fields)))
                                       (= @step (inc @steps-total))))
                                 (> (count allowed-languages) 1))
                            [form-page-header {:current-page current-page :step step :steps-total steps-total
                                             :has-thank-you-screen? (= "thank_you_screen" (:type (last display-fields)))
                                             :theme-data theme-data :form-messages form-messages
                                             :avatar-img-link form-icon :language-direction language-direction
                                             :missing-required-fields missing-required-fields}])
                          (if (> @step @steps-total) 
                                  ;;  (= "thank_you_screen" (:type (last display-fields))))
                            [thank-you-field {:field (when (= "thank_you_screen" (:type (first (:fields (last grouped-display-fields))))) (first (:fields (last grouped-display-fields))))
                                              :selected-language selected-language
                                              :theme-data theme-data :hidden-fields hidden-fields
                                              :display-fields display-fields}]
                            [(r/adapt-react-class SwipeableViews)
                             {:index @current-page
                              :axis (if (= language-direction "RTL") "x-reverse" "x")
                              :onChangeIndex #(reset! current-page %)
                              :style {:display "flex"
                                      :direction "ltr"
                                      :justify-content "center"}
                              :springConfig #js{:duration "2s"
                                                :delay "2s"}
                              :class (form-content-style)} ;TODO: try and set class (OR ID wrap in div) then pass name as arg to function
                             (map-indexed (fn [index field]
                                            (when (jump-to-next-question? index pre-filled counter)
                                              (jump-to-next-question! {:input-data input-data :display-fields display-fields
                                                                       :pre-filled pre-filled :current-page current-page
                                                                       :index index :counter counter :steps-total steps-total}))
                                            (r/as-element
                                             [form-swipeable-panel {:index index :display-fields display-fields
                                                                    :selected-language selected-language :theme-data theme-data :form-messages form-messages
                                                                    :current-page current-page :hidden-fields hidden-fields
                                                                    :input-data input-data :on-submit on-submit
                                                                    :step step :steps-total steps-total
                                                                    :pre-filled pre-filled :regenerate-display-fields regenerate-display-fields
                                                                    :grouped-display-fields grouped-display-fields
                                                                    :language-direction language-direction
                                                                    :has-thank-you-screen? (= "thank_you_screen" (:type (last display-fields)))
                                                                    :missing-required-fields missing-required-fields}])) grouped-display-fields)])

                          [form-page-footer {:form-messages form-messages}]
                          (when (and (not
                                      (and
                                       (= "thank_you_screen" (:type (last display-fields)))
                                       (= @step (inc @steps-total))))
                                     (<= (.-innerWidth js/window) 1100)
                                     review-responses)
                            [mobile-progress-bar {:display-fields display-fields :input-data input-data :selected-language selected-language :theme-data theme-data :hidden-fields hidden-fields :form-messages form-messages :open-drawer open-drawer}])]]
              (when (and (not
                          (and
                           (= "thank_you_screen" (:type (last display-fields)))
                           (= @step (inc @steps-total))))
                         (> (.-innerWidth js/window) 1100)
                         review-responses)
                [box
                 :size "2"
                 :style {:background-color (str (:background_color theme-data) "9c")}
                 :child
                 [responses-preview {:display-fields display-fields :input-data input-data :selected-language selected-language
                                     :theme-data theme-data :hidden-fields hidden-fields :form-messages form-messages
                                     :language-direction language-direction
                                     :grouped-display-fields grouped-display-fields :current-page current-page}]])
              (when (and (not
                          (and
                           (= "thank_you_screen" (:type (last display-fields)))
                           (= @step (inc @steps-total))))
                         (<= (.-innerWidth js/window) 1100)
                         review-responses)
                [swipeable-drawer
                 {:open @open-drawer
                  :anchor "bottom"
                  :on-close #(reset! open-drawer false)
                  :on-open #(reset! open-drawer true)
                  :class (response-drawer-style)
                  :style {:border-radius "20px"}}
                 [:div
                  {:style {:height "60vh"
                           :overflow-y "hidden"}}
                  [responses-preview {:display-fields display-fields :input-data input-data :selected-language selected-language
                                      :theme-data theme-data :hidden-fields hidden-fields :form-messages form-messages
                                      :open-drawer open-drawer  :language-direction language-direction
                                      :grouped-display-fields grouped-display-fields :current-page current-page}]]])]])

(defn- page-contains-title? [current-page children-element steps-total page-titles]
  (and (> @current-page 0) (some? children-element) (< @current-page @steps-total)
       (some? (.item children-element @current-page))
       (some? (:page_title (nth page-titles @current-page)))))

(defn- page-scrolled-10-pixels? [children-element current-page]
  (>= (.-scrollTop (.item children-element @current-page)) 10))

(defn strive-forms-container []
  (let [error-form-message (re-posh/subscribe [::subs/error-form-messages])
        form-data  (re-posh/subscribe [::subs/form-data])
        current-page (r/atom 0)
        counter (r/atom 0)
        open-drawer (r/atom false)
        missing-required-fields (r/atom [])
        auto-submitted (r/atom false)]
    (when  (and  (some? @form-data) (:auto_submit_enabled (:form-filling/form-data @form-data)))
      (timer/in timer/main-thread
                (if (some? (:auto_submit_duration (:form-filling/form-data @form-data)))
                  (* (:auto_submit_duration (:form-filling/form-data @form-data)) 10000) 
                  30000)
                (fn my-task []
                  (re-frame/dispatch [::events/submit-form
                                      {:input-data (:form-filling/input-data @form-data)
                                       :display-fields (:form-filling/display-fields @form-data)
                                       :include-all-paths? (:include_all_paths (:form-filling/form-data @form-data))
                                       :form-id (:form_id (:form-filling/form-data @form-data))
                                       :is-test false
                                       :is-sms false
                                       :landed-at (.format (moment) "YYYY-MM-DD HH:mm:ss")
                                       :is-mobile false
                                       :auto-submitted true
                                       :selected-language (:form-filling/form-language @form-data)
                                       :hidden-fields (:form-filling/hidden-fields @form-data)
                                       :send-emails nil
                                       :response-id (uuidv4)}])
                  (swap! auto-submitted not)
                  )))
    (fn []
      (let [{:keys [theme include_all_paths form_id review_responses auto_submit_enabled auto_submit_duration]} (:form-filling/form-data @form-data)
            display-fields (:form-filling/display-fields @form-data)
            selected-language (:form-filling/form-language @form-data)
            language-direction (:form-filling/language-direction @form-data)
            allowed-languages (:form-filling/allowed-languages @form-data)
            form-messages  (:form-filling/form-messages @form-data)
            form-icon (:form-filling/icon @form-data "https://storage.googleapis.com/ninja_images/hp-logo.webp")
            theme-data (:theme_data theme)
            pre-filled  (:form-filling/prefilled-answer @form-data)
            hidden-fields (:form-filling/hidden-fields @form-data)
            input-data (:form-filling/input-data @form-data)
            landed_at (.format (moment) "YYYY-MM-DD HH:mm:ss")
            on-submit #(re-frame/dispatch [::events/submit-form
                                           {:input-data %
                                            :display-fields display-fields
                                            :include-all-paths? include_all_paths
                                            :form-id form_id
                                            :is-test false
                                            :is-sms false
                                            :landed-at landed_at
                                            :is-mobile false
                                            :selected-language selected-language
                                            :hidden-fields hidden-fields
                                            :send-emails nil
                                            :response-id (uuidv4)}])
            regenerate-display-fields (fn [data]
                                        (re-frame/dispatch [::events/regenerate-display-fields
                                                            {:form-fields (:form-filling/form-fields @form-data)
                                                             :logic-flow (:form-filling/logic-flow @form-data)
                                                             :input-data data}]))
            step (r/atom (inc @current-page))
            grouped-display-fields (create-group-display-fields display-fields)
            steps-total (r/atom (if (= "thank_you_screen" (:type (last display-fields)))
                                  (dec (count grouped-display-fields))
                                  (count grouped-display-fields)))
            elements (first (.getElementsByClassName js/document "react-swipeable-view-container"))
            children-element (if (some? elements) (.-children elements) nil)
            page-titles (map (fn [value]
                               (first (:fields value))) grouped-display-fields)
            scrolled? (r/atom (if (page-contains-title? current-page children-element steps-total page-titles)
                                (page-scrolled-10-pixels? children-element current-page)
                                nil))]
        
        [v-box
         :src      (at)
         :height "100vh"
         :size "auto"
         :class (form-container-theme)
         :children [(if (blank? (:form-filling/error-form-messages @error-form-message))
                      (if (and (some? display-fields) (not @auto-submitted))
                        [question-page {:theme-data theme-data :current-page current-page :selected-language selected-language
                                        :hidden-fields hidden-fields :display-fields display-fields :pre-filled pre-filled
                                        :counter counter :input-data input-data :form-messages form-messages :on-submit on-submit
                                        :regenerate-display-fields regenerate-display-fields :form_id form_id :form-icon form-icon :step step
                                        :language-direction language-direction :allowed-languages allowed-languages :review-responses review_responses
                                        :open-drawer open-drawer :steps-total steps-total :scrolled? scrolled?
                                        :page-titles page-titles :children-element children-element
                                        :grouped-display-fields grouped-display-fields
                                        :missing-required-fields missing-required-fields}]
                        [thank-you-field])
                      [header {:label (:form-filling/error-form-messages @error-form-message)
                               :type :large :size :semibold
                               :style {:height "100vh" :justify-content "center" :align-items "center"}}])]]))))

(defmethod routes/panels :strive-forms-panel [] [strive-forms-container])